import { SUPPORT_EMAIL } from "@Common/constants";
import { PublicFooter } from "@Src/components/PublicFooter";
import { PublicNav } from "@Src/components/PublicNav";
import { RetrowaveBackground } from "@Src/components/RetrowaveBackground";
import EmailIcon from "@mui/icons-material/Email";
import { Box, Container, Paper, Typography } from "@mui/material";

export const ContactComponent = () => {
	return (
		<Box sx={{ display: "flex", justifyContent: "center" }}>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					gap: 3,
					width: { xs: "100%", md: "33.33%" },
				}}
			>
				<Paper
					elevation={0}
					sx={{
						p: 3,
						border: "1px solid",
						borderColor: "divider",
						borderRadius: 2,
					}}
				>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							mb: 2,
						}}
					>
						<EmailIcon
							sx={{
								color: "primary.main",
								fontSize: "2rem",
								mr: 2,
							}}
						/>
						<Typography
							variant="h6"
							sx={{
								fontWeight: 600,
								color: "text.primary",
							}}
						>
							Email Us
						</Typography>
					</Box>
					<Typography
						variant="body2"
						sx={{
							color: "text.secondary",
							mb: 1,
						}}
					>
						For all inquiries:
					</Typography>
					<Typography
						variant="body2"
						sx={{
							color: "primary.main",
							fontWeight: 500,
						}}
					>
						{SUPPORT_EMAIL}
					</Typography>
				</Paper>
			</Box>
		</Box>
	);
};

export const ContactPage = () => {
	return (
		<Box
			sx={{
				minHeight: "100vh",
				bgcolor: "background.default",
				position: "relative",
				overflow: "hidden",
			}}
		>
			<PublicNav />

			<RetrowaveBackground />

			<Container
				maxWidth="lg"
				sx={{ py: { xs: 8, md: 12 }, position: "relative", zIndex: 1 }}
			>
				<Box
					sx={{
						maxWidth: 700,
						mx: "auto",
						textAlign: "center",
						mb: 8,
					}}
				>
					<Typography
						variant="h1"
						sx={{
							fontSize: { xs: "2.5rem", md: "3.5rem" },
							fontWeight: 700,
							color: "text.primary",
							mb: 3,
						}}
					>
						Get in Touch
					</Typography>
					<Typography
						variant="h5"
						sx={{
							color: "text.secondary",
							fontWeight: 400,
							fontSize: { xs: "1.125rem", md: "1.25rem" },
						}}
					>
						Have questions? We'd love to hear from you. Send us a message and
						we'll respond as soon as possible.
					</Typography>
				</Box>

				<ContactComponent />
			</Container>

			<PublicFooter />
		</Box>
	);
};
